module.exports = __webpack_public_path__ + "images/cv_bulk_arrow_head_1644981b707cfc36a70090b7438650fa.png";